import React from "react";
import UniversalWorklistLayout from "./components/UniversalWorklistLayout";

interface OfficeMailsPageProps {}

const OfficeMailsPage = (props: OfficeMailsPageProps) => {
  return (
    <UniversalWorklistLayout>
      <div className="text-center py-5">
        <i className="ti ti-mail fs-48 text-muted mb-3 d-block"></i>
        <h4 className="text-muted mb-2">No SAPoffice Mails</h4>
        <p className="text-muted">There are currently no office mails to display.</p>
      </div>
    </UniversalWorklistLayout>
  );
};

export default OfficeMailsPage;
